import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-bsbreadcrumb-container',
	templateUrl:'./BSBreadcrumbContainerPage.html',
	styles: [],
	styleUrls:['./BSBreadcrumbContainerPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSBreadcrumbContainerPage
{
	mdContent_66 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.breadcrumbs.BSBreadcrumbContainer;
\`\`\``;
	mdContent_67 = `\`\`\`java
new BSBreadcrumbContainer<>()
\`\`\``;
	mdContent_68 = `\`\`\`java
var bc = new BSBreadcrumbContainer<>();
var crumb = new BSBreadCrumb<>();
crumb.add(new BSBreadCrumbItem<>(new BSBreadCrumbLink<>("Home", "/")));
crumb.add(new BSBreadCrumbItem<>().setText("Current Page"));
bc.add(crumb);
\`\`\``;
}
